import BaseView from './base-view';
import FormUtil from '../utils/form-util';
import TrayExpand from '../utils/tray-expand';

class NewsletterSignup extends BaseView {
	//el() { return '#page-header' },

	events() {
		return {

		};
	}

	postInitialize() { return {}; }

	bindings() { return {}; }

	listeners() {
		this.listenTo(this.pubSub, 'formUtilSubmitDone', this.handleFormUtilSubmitDone, this);
		this.listenTo(this.pubSub, 'formUtilSubmitFail', this.handleFormUtilSubmitFail, this);
	}

	postRender() {
		// form stuff
		this.$formFeedbackContainer = $('.form-feedback-container', this.$form);
		this.$feedbackWrap = $('.form-feedback', this.$formFeedbackContainer);
		this.$feedback = $('.desc', this.$feedbackWrap);
		this.feedbackShowing = false;

		this.buildFormValidation();
		return this;
	}

	/**
	 * Build form validation for each form on the page
	 */
	buildFormValidation() {
		const formWraps = document.querySelectorAll('.form');
		formWraps.forEach((self) => {
			// check if the form's data-type is 'subscribe'
			const formType = self.getAttribute('data-type');
			if (formType === 'subscribe') {
				const formUtil = new FormUtil();
				formUtil.init({
					action: 'subscribe', // API call being made
					pubSub: this.pubSub, // for event dispatching
					$form: $(self), // jquery form reference
					formName: self.id, // form name, for FormValidator
					$feedback: $('.form-feedback-container .desc', self),
					$curBtn: $('#subscribe-btn', this.$el),
					hasGender: false, // this form does not have a gender field
					hasDOB: false, // this form does not have a dob field
					validateFieldsAr: [
						// email
						{
							name: 'email',
							display: 'Email',
							rules: 'required|valid_email',
						},
						// Privacy Policy
						{
							name: 'privacy',
							display: 'Privacy Policy',
							rules: 'required',
						},
					],
					paramsAr: [
						{
							param: 'email',
							field: 'email',
							type: 'val',
						}
					],
				});
			}
		});
	}
	/**
	 * Handle the show of feedback
	 * type: supported [styled] values are warning, error, info, success
	 */
	showFeedback(type, message) {
		var self = this;
		// if feedback is showing, then hide it first
		if (this.feedbackShowing) {
			// pass this function as a callback, and also this function's arguments.
			this.hideFeedback(this.showFeedback, type, message);
		} else {
			// feedback is not showing - populate and show it
			this.$feedbackWrap.addClass(type);
			this.$feedback.html(message);
			TrayExpand.expand(this.$feedbackWrap, this.$formFeedbackContainer, function () {
				// mark feedback as showing
				self.feedbackShowing = true;
			});
			//ProjectUtil.animateToElTop(this.$feedbackWrap[0]); // not ready
		}
	}

	/**
	 * Handle the hide of the feedback
	 */
	hideFeedback(cb_func) {
		var self = this,
			args = Array.prototype.slice.call(arguments);

		// these are the args to be applied to callback function
		args.shift();

		// only hide if showing
		if (this.feedbackShowing) {
			// collapse the tray
			TrayExpand.collapse(this.$feedbackWrap, this.$formFeedbackContainer, function () {
				// mark feedback as not shoing
				self.feedbackShowing = false;
				// clear type classes
				self.$feedbackWrap.removeClass('warning error info success');
				self.$feedback.empty();
				// call the callback function
				if (cb_func) {
					cb_func.apply(self, args);
				}
			});
		}
	}

	/**
	 * Handle form submission responses from FormUtil
	 * tObj: properties 'action' and 'response'
	 */
	handleFormUtilSubmitDone(tObj) {
		if (tObj?.response?.data?.status === 'ok') {

			// handle all status 'ok' responses here.
			this.showFeedback('success', 'You have been successfully subscribed!');
		} else {
			// get the error message
			//let tMsg = tObj.response.errorMsg.split('|').findLast((item) => true); // throwing JSHint error
			let tMsg = tObj.response.errorMsg.split('|').findLast(() => true);
			// handle all status 'error' responses here.
			this.showFeedback('error', 'Subscription failed.<br>' + tMsg);
		}
	}

	/**
	 * Handle form submission fails from FormUtil
	 * tObj: properties 'action' and 'textStatus'
	 * TODO: SHOW ERRORS
	 */
	handleFormUtilSubmitFail(/*tObj*/) {
		this.showFeedback('error', 'Subscription failed.<br>There was a problem with the server.');
	}

	cleanup() {

	}

}

export default NewsletterSignup;